import React, { useEffect, useState } from "react"

import styles from "../styles/navigator.module.css"
import logo from "../assets/images/crown.svg"

export default function Navigator({showPrivacy}) {
  const [scroll, setScroll] = useState(false)
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 120)
    })
  }, [])
  const bgClassName = scroll ? styles.noBg : styles.withBg
  return (
    <nav className={styles.container}>
      <div className={[styles.bg, bgClassName].join(" ")} />
      <img className={styles.logo} src={logo} alt="Logo" />
      <h2 className={styles.title}>Meritas</h2>

      <div className={styles.links}>
        <h4 onClick={showPrivacy}><a className={styles.link}>Privacy</a></h4>
        <h4><a className={styles.link} href="mailto:codaxelabs@gmail.com">Contact</a></h4>
      </div>
    </nav>
  )
}
